import { URL } from "../../static/vars";

export function getTokens(callback) {
    fetch(URL + '/tokens', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        })
    })
        .then((response) => response.json())
        .then((data) => {
            return callback(data)
        });
}

export function preCalcNew(params, callback) {
    fetch(URL + '/precalcnewtestpari', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
    })
        .then((response) => response.json())
        .then((data) => {
            return callback(data)
        });
}

export function preCalculate(params, callback) {
    try {
        fetch(URL + '/precalculate', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((data) => {
                return callback(data)
            });
        }
    catch (e) {
        // console.log('preCalculate', e.message)
        return callback({})
    }
}

export function getDescription(params, callback) {
    fetch(URL + '/description', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
    })
        .then((response) => response.json())
        .then((data) => {
            // console.log('description', data)
            return callback(data)
        });
}